<template>
    <div>
        <b-row>
            <!-- Form -->
            <b-col cols="12" md="6">
                <b-card no-body>
                    <b-card-body>
                        <b-row>
                            <b-col cols="12" md="3">
                                <b-form-group label-for="season_id" label="Season">
                                    <validation-provider #default="{ errors }" name="season_id" rules="">
                                        <b-form-select
                                            size="sm"
                                            v-model="estimate.season_id"
                                            id="season_id"
                                            name="season_id"
                                            :state="errors.length > 0 ? false : null"
                                            disabled
                                        >
                                            <b-form-select-option
                                                v-for="season in seasons"
                                                :key="season.id"
                                                :value="season.id"
                                                :selected="season.isRunning"
                                            >
                                                {{ season.startYear }}/{{ season.endYear }}
                                            </b-form-select-option>
                                        </b-form-select>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                        <small class="text-danger" v-if="serverErrors && serverErrors.season_id">{{ serverErrors.season_id[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col cols="12" md="12" class="mb-md-0 mb-2">
                                <location-filters size="sm" align="horizontal" @filter="changeFilter" />
                            </b-col>
                        </b-row>

                        <b-row class="mt-1">
                            <b-col cols="6" md="6" class="mb-md-0 mb-2">
                                <validation-provider #default="{ errors }" name="value" rules="required">
                                    <label for="target_id">Target {{ locationLabel }}</label>
                                    <b-form-select
                                        id="target_id"
                                        name="target_id"
                                        size="sm"
                                        v-model="estimate.target_id"
                                        @change="changeEstimate()"
                                    >
                                        <b-form-select-option :value="null">Select...</b-form-select-option>
                                        <b-form-select-option
                                            v-for="location in locations"
                                            :key="location.id"
                                            :value="location.id"
                                        >
                                            {{ location.name.toUpperCase() }}
                                        </b-form-select-option>
                                    </b-form-select>
                                    <small class="text-danger" v-if="serverErrors && serverErrors.target_id">{{ serverErrors.target_id[0] }}</small>
                                </validation-provider>
                            </b-col>
                        </b-row>

                        <b-row class="mt-1">
                            <b-col cols="6" md="6" class="mb-md-0 mb-2">
                                <b-form-group label-for="value" label="Est. Volume">
                                    <validation-provider #default="{ errors }" name="value" rules="required">
                                        <b-input-group size="sm" prepend="KGs">
                                            <b-form-input
                                                v-model="estimate.value"
                                                type="number"
                                                style="text-align:left;"
                                                :disabled="saving || !estimate.editing"
                                                @keyup.enter="saveValue()"
                                            />
                                            <b-input-group-append is-text title="Edit target" @click="cancelEditValue()" v-if="!estimate.editing">
                                                <feather-icon
                                                    icon="Edit3Icon"
                                                    class="cursor-pointer"
                                                />
                                            </b-input-group-append>
                                            <b-input-group-append is-text title="Cancel editing" @click="cancelEditValue()" v-else>
                                                <b-spinner
                                                    small
                                                    class="mr-1"
                                                    label="Small Spinner"
                                                    variant="primary"
                                                    v-if="saving"
                                                />
                                                <feather-icon
                                                    icon="XIcon"
                                                    class="cursor-pointer"
                                                    v-else
                                                />
                                            </b-input-group-append>
                                        </b-input-group>
                                        <small class="text-danger" v-if="serverErrors && serverErrors.value">{{ serverErrors.value[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>
            </b-col>
            <!-- ./Form -->

            <!-- Table Container Card -->
            <b-col cols="12" md="6">
                <b-card no-body>
                    <b-card-body>
                        <b-table
                            striped
                            hover
                            small
                            ref="records"
                            class="position-relative"
                            :items="locations"
                            responsive
                            :fields="columns"
                            primary-key="id"
                            show-empty empty-text="No records found"
                        >
                            <template #cell(name)="data">
                                <span class="text-capitalize">{{ data.item.name }}</span>
                            </template>

                            <template #cell(target)="data">
                                <span v-if="data.item.targets.length === 0 && data.item.target <= 0"></span>
                                <span v-else>{{ data.item.target.toLocaleString() }} KGs</span>
                            </template>
                        </b-table>
                    </b-card-body>
                </b-card>
            </b-col>
            <!-- ./Table Container Card -->
        </b-row>
    </div>
  </template>
  
  <script>
  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import {
    BRow, BCol, BCard, BCardHeader, BCardBody, BTable, BPagination,
    BForm, BFormGroup, BButton, BFormSelect, BFormSelectOption, BFormInput, BDropdown, BDropdownItem, BSpinner,
    BInputGroupAppend,
    BInputGroup,
  } from 'bootstrap-vue'
  import LocationFilters from '@core/components/cromis/filters/LocationFilters'
  import vSelect from 'vue-select'
  import { required } from '@validations'
  import store from '@/store'
  import { ref, onMounted, onUnmounted } from '@vue/composition-api'
  import estimatesStoreModule from '@/views/cromis/estimates/estimatesStoreModule'
  import useEstimatesList from '@/views/cromis/estimates/useEstimatesList'
  export default {
    props: {},
    components: {
        BRow,
        BCol,
        BCard,
        BCardHeader,
        BCardBody,
        BTable,
        BPagination,
        BForm,
        BFormGroup,
        BButton,
        BFormSelect,
        BFormSelectOption,
        BFormInput,
        BInputGroupAppend,
        BInputGroup,
        vSelect,
        BDropdown,
        BDropdownItem,
        BSpinner,
        ValidationObserver,
        ValidationProvider,
        LocationFilters,
    },
    directives: {},
  
    setup(props, context) {
        const dataForm = ref(null)
        const myModal = ref(null)
        const saving = ref(false)
        const serverErrors = ref(null)

        const seasons = ref([])
        const locations = ref([])
        const filtered = ref(null)
        const locationLabel = ref(null)

        const columns = ref([
            { key: "name", label: "Location", sortable: true, thStyle: { width: "50%" }, thClass: 'text-left', tdClass: 'text-left'},
            { key: "target", thClass: 'text-right', tdClass: 'text-right'},
        ])

        const estimate = ref({
            id: null,
            season_id: null,
            target_id: null,
            type: 1,
            value: null,
            prevValue: null,
            editing: false,
        })

  
        const CROMIS_STORE_MODULE_NAME = "cromis-estimates";
  
        // Register module
        if (!store.hasModule(CROMIS_STORE_MODULE_NAME)) store.registerModule(CROMIS_STORE_MODULE_NAME, estimatesStoreModule);
  
        // UnRegister on leave
        onUnmounted(() => {
            if (store.hasModule(CROMIS_STORE_MODULE_NAME)) store.unregisterModule(CROMIS_STORE_MODULE_NAME);
        });
  
        onMounted(async () => {
            await store.dispatch("cromis-estimates/seasons")
                .then((response) => {
                seasons.value = response.data.seasons;
                seasons.value.map((season) => {
                    if (season.isRunning) {
                    estimate.value.season_id = season.id
                    }
                })
                })
                .catch((error) => {
                    console.log("got error", error);
                });

            await store.dispatch('cromis-estimates/locations')
                .then((response) => {
                    locations.value = response.data.locations

                    if(locations.value.length > 0){
                        locationLabel.value = locations.value[0].level.name
                    }
                })
                .catch((error) => {
                    console.log("got error", error);
                });
        })

        const changeFilter = async (location) => {
            filtered.value = location
            locationLabel.value = filtered.value !== null ? filtered.value.level.children[0].name : null
            serverErrors.value = null
            await store.dispatch('cromis-estimates/locations', { location_id: filtered.value !== null ? filtered.value.id : null, season_id: estimate.value.season_id })
                .then((response) => {
                    locations.value = response.data.locations
                })
                .catch((error) => {
                    console.log("got error", error);
                });
            
            estimate.value.target_id = null
            estimate.value.value = null
            estimate.value.prevValue = null
            estimate.value.editing = false
        }

        const changeEstimate = () => {
            if(estimate.value.target_id !== null){
                locations.value.forEach((e) => {
                    if(e.id == estimate.value.target_id){
                        estimate.value.value = (e.targets.length === 0 && e.target <= 0)? null : e.target
                        estimate.value.prevValue = (e.targets.length === 0 && e.target <= 0)? null : e.target
                        estimate.value.editing = false
                    }
                })
            }
            else{
                estimate.value.value = null
                estimate.value.prevValue = null
                estimate.value.editing = false
            }
        }

        const cancelEditValue = () => {
            estimate.value.editing = !estimate.value.editing
            estimate.value.value = estimate.value.prevValue
        }

        const saveValue = async () => {
            if(estimate.value.value == null || estimate.value.value == estimate.value.prevValue){
                estimate.value.value = estimate.value.prevValue
                estimate.value.editing = !estimate.value.editing
            }
            else{
                saving.value = true

                await store.dispatch('cromis-estimates/saveTarget', estimate.value)
                        .then((response) => {
                            saving.value = false
                            serverErrors.value = null

                            estimate.value.target_id = null
                            estimate.value.value = null
                            estimate.value.prevValue = null
                            estimate.value.editing = false

                            locations.value.forEach((e) => {
                                if(e.id == response.data.target_id){
                                    if(response.data.target !== undefined){
                                        e.target = response.data.target
                                    }
                                    else{
                                        e.target =  parseFloat(''+response.data.value)
                                    }
                                }
                            })
                        })
                        .catch((error) => {
                            console.log(error)
                            saving.value = false
                            if (error.response.status === 422) {
                                serverErrors.value = error.response.data.errors
                            }
                            else {
                                console.log(error.response)
                                context.root.$swal({
                                    icon: 'error',
                                    title: 'Server Error',
                                    text: 'Something went wrong. See tech support',
                                    showConfirmButton: true,
                                    customClass: {
                                        confirmButton: 'btn btn-danger',
                                    },
                                    buttonsStyling: false,
                                })
                            }
                        })
            }
        }
  
        return {
            dataForm,
            myModal,
            saving,
            serverErrors,

            seasons,
            locations,
            filtered,
            locationLabel,
            estimate,

            changeFilter,
            changeEstimate,
            cancelEditValue,
            saveValue,

            columns,
        };
    },
};
</script>

<style lang="scss" scoped>
@import "@core/scss/vue/libs/vue-select.scss";
</style>
  